// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import {
  getOrdersByShipmentFormatted,
  getOrderByShipmentFetchingState,
} from '@tcp/core/src/components/features/account/common/organism/OrdersTile/container/OrdersTile.selectors';
import { getOrderListByShipment } from '@tcp/core/src/components/features/account/common/organism/OrdersTile/container/OrdersTile.actions';
import ordersTileConstants from '@tcp/core/src/components/features/account/common/organism/OrdersTile/OrdersTile.constants';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import { getIsAccountDashboardOrdersEnabled } from '../../../../../../../reduxStore/selectors/session.selectors';
import {
  getOrdersListState,
  getOrderListFetchingState,
  getShowOrderListWithItemDetails,
} from '../../../../Orders/container/Orders.selectors';
import { getOrdersList } from '../../../../Orders/container/Orders.actions';
import OrdersTileSkelton from '../skelton/OrdersTileSkelton.view';
import OrdersRedesignTile from '../views/OrdersRedesignTile.view';
import OrdersTileSagas from './OrdersTile.saga';
import OrdersTileReducer from './OrdersTile.reducer';

class OrdersTile extends PureComponent {
  componentDidMount() {
    const { fetchOrderListByShipment, isAccountDashboardOrdersEnabled } = this.props;
    if (isAccountDashboardOrdersEnabled) {
      const newListPayload = {
        reqParams: {
          pageNumber: 0,
          pageSize: ordersTileConstants.ORDER_SIZE,
        },
      };
      fetchOrderListByShipment(newListPayload);
    }
  }

  render() {
    const { isFetching, globalLabels, orderList, isDashboardOrdersFetching } = this.props;

    if (isFetching || isDashboardOrdersFetching) {
      return <OrdersTileSkelton />;
    }
    return <OrdersRedesignTile orderList={orderList?.shipmentList} globalLabels={globalLabels} />;
  }
}

OrdersTile.propTypes = {
  fetchOrders: PropTypes.func,
  ordersListItems: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({}).isRequired,
  handleComponentChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  isDashboardOrdersFetching: PropTypes.bool,
  showOrderListWithItemDetails: PropTypes.bool,
  orderHistoryOptimized: PropTypes.bool,
  isAccountDashboardOrdersEnabled: PropTypes.bool,
};

OrdersTile.defaultProps = {
  fetchOrders: () => {},
  isFetching: false,
  showOrderListWithItemDetails: false,
  orderHistoryOptimized: false,
  isAccountDashboardOrdersEnabled: false,
  isDashboardOrdersFetching: false,
};
export const mapStateToProps = (state) => ({
  ordersListItems: getOrdersListState(state),
  isFetching: getOrderListFetchingState(state),
  showOrderListWithItemDetails: getShowOrderListWithItemDetails(state),
  orderList: getOrdersByShipmentFormatted(state),
  isAccountDashboardOrdersEnabled: getIsAccountDashboardOrdersEnabled(state),
  isDashboardOrdersFetching: getOrderByShipmentFetchingState(state),
});

export const mapDispatchToProps = (dispatch) => ({
  fetchOrders: (payload) => {
    dispatch(getOrdersList(payload));
  },
  fetchOrderListByShipment: (payload) => {
    dispatch(getOrderListByShipment(payload));
  },
});

export { OrdersTile as OrdersTileVanilla };

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withDynamicSaga({ key: 'DashboardOrders', saga: OrdersTileSagas });
const withReducer = withDynamicReducer({
  key: 'DashboardOrders',
  reducer: OrdersTileReducer,
});

export default compose(withReducer, withSaga, withConnect)(OrdersTile);
